import { render, staticRenderFns } from "./rewardQuery.vue?vue&type=template&id=39a68e89&scoped=true"
import script from "./rewardQuery.vue?vue&type=script&lang=js"
export * from "./rewardQuery.vue?vue&type=script&lang=js"
import style0 from "./rewardQuery.vue?vue&type=style&index=0&id=39a68e89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a68e89",
  null
  
)

export default component.exports